'use client';

import { ElementRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@/lib/utils';

const Progress = ({
  ref,
  className,
  value,
  ...props
}: ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
  ref?: React.RefObject<ElementRef<typeof ProgressPrimitive.Root> | null>;
}) => {
  const clampedValue = Math.max(0, Math.min(100, value || 0));

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'bg-secondary relative h-4 w-full overflow-hidden rounded-full',
        className
      )}
      value={value}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="bg-primary h-full w-full flex-1 transition-all"
        style={{ transform: `translateX(-${100 - clampedValue}%)` }}
      />
    </ProgressPrimitive.Root>
  );
};
Progress.displayName = ProgressPrimitive.Root.displayName || 'Progress';

export { Progress };
